import { render, staticRenderFns } from "./user-dash-quotes.vue?vue&type=template&id=4915f740&"
import script from "./user-dash-quotes.vue?vue&type=script&lang=js&"
export * from "./user-dash-quotes.vue?vue&type=script&lang=js&"
import style0 from "./user-dash-quotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports